import { useCallback } from "react";
import {
  MelcoModelsUser,
  UserManagementApi,
  useAPIAction,
} from "melco-shared-logic";

export const useUnlockUser = () => {
  const [unlockUser] = useAPIAction(
    UserManagementApi,
    async (api, user: MelcoModelsUser) => {
      const data = await api.userUnlock({
        id: user?.id ?? "",
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "users.actions.unlock",
    }
  );

  return useCallback(
    async (user: MelcoModelsUser) => {
      try {
        await unlockUser(user);
      } catch (e) {
        return { success: false };
      }

      return { success: true };
    },
    [unlockUser]
  );
};
